import { useHomePage } from '../HomePageProvider'
import { SectionHeader } from '../SectionHeader'

import { ConnectChannelCard } from './ConnectChannelCard'
import { CreateFirstPostCard } from './CreateFirstPostCard'
import { InviteTeamCard } from './InviteTeamCard'
import { TryBufferApiCard } from './TryBufferApiCard'

import styles from './FirstSteps.module.css'

import type { JSX } from 'react'

export function FirstSteps(): JSX.Element {
  const { isTeamContext } = useHomePage()

  return (
    <div className={styles.root}>
      <SectionHeader>First Steps</SectionHeader>
      <div className={styles.grid}>
        <ConnectChannelCard />
        <CreateFirstPostCard />
        {isTeamContext ? <InviteTeamCard /> : <TryBufferApiCard />}
      </div>
    </div>
  )
}
